import { mapMutations, mapActions } from "vuex";
import { orderTypeHelper } from "../../api/helpers/orderTypeHelper";
import {
  CONSTANT_ORDER_TYPE_DELIVERY,
  CONSTANT_ORDER_TYPE_PICKUP,
  CONSTANT_ORDER_TYPE_DINEIN,
} from "../../constans/strings.js";

export default {
  methods: {
    ...mapMutations([
      "setStore",
      "setSelectedMenuType",
      "setIsDelivery",
      "setIsPickup",
    ]),
    ...mapActions(["initStore"]),
    filterCategory(menu, category) {
      let find = null;
      for (let index = 0; index < menu.Categories.length; index++) {
        const item = menu.Categories[index];
        if (item.Name.toLowerCase() == category.toLowerCase()) {
          find = item;
          break;
        }
      }
      menu.Categories = [find];
      this.storeMenu = menu;
    },
    storeSupportsDelivery: orderTypeHelper.storeSupportsDelivery,
    storeSupportsDinein: orderTypeHelper.storeSupportsDinein,
    storeSupportsPickup: orderTypeHelper.storeSupportsPickup,
    initiateWorkflow() {
      if(!this.isMobile() && this.enabledMultipleMenus) {
        this.showOrderTypeSelection = true;
      } else {
        this.showOrderTypeSelection = false;
        if(!orderTypeHelper.getOrderType()) {
          if(this.storeSupportsDelivery(this.selectedCompany)) {
            orderTypeHelper.setOrderTypeDelivery();
            this.setSelectedMenuType(CONSTANT_ORDER_TYPE_DELIVERY);
            this.setIsDelivery(true);
          } else if(this.storeSupportsPickup(this.selectedCompany)) {
            orderTypeHelper.setOrderTypePickup();
            this.setSelectedMenuType(CONSTANT_ORDER_TYPE_PICKUP);
            this.setIsDelivery(false);
          } else if(this.storeSupportsDinein(this.selectedCompany)) {
            orderTypeHelper.setOrderTypeDineIn();
            this.setSelectedMenuType(CONSTANT_ORDER_TYPE_DINEIN);
            this.setIsDelivery(false);
          }
        }
      }
    },
  },
  computed: {
    enabledMultipleMenus() {
      return this.selectedCompany
        && this.selectedCompany.ViewComponentConfigs
        && this.selectedCompany.ViewComponentConfigs.MultipleMenus == true;
    },
  },
  watch: {
    enabledMultipleMenus() {
      this.initiateWorkflow();
    },
  },
};
